// Leergut je Art – wie im Formular („13x Schweißgas, 3 Bündel, 24x Treibgas“).
// Gleiche Regeln wie api/src/routes/gasBestellungen.ts (LEERGUT_ARTEN):
// Schweißgas, Treibgas und Bündel zählen für den Flaschen-Vertrag, die Gitterbox nicht.
export const LEERGUT_ARTEN = [
  { k: 'schweissgas', label: 'Schweißgas', text: (n: number) => `${n}x Schweißgas`, zaehlt: 1, muster: /schwei/i },
  { k: 'buendel', label: 'Bündel', text: (n: number) => `${n} Bündel`, zaehlt: 1, muster: /b[üu]ndel/i },
  { k: 'treibgas', label: 'Treibgas', text: (n: number) => `${n}x Treibgas`, zaehlt: 1, muster: /treib/i },
  { k: 'gitterbox', label: 'Gitterbox', text: (n: number) => `${n} Gitterbox`, zaehlt: 0, muster: /gitter/i },
] as const;
export type LeergutArt = (typeof LEERGUT_ARTEN)[number]['k'];
export type LeergutEingabe = Partial<Record<LeergutArt, string>>;

const zahl = (v?: string | number) => { const n = parseFloat(String(v ?? '').replace(',', '.')); return Number.isFinite(n) ? n : 0; };

export const leergutText = (d: LeergutEingabe) =>
  LEERGUT_ARTEN.filter((a) => zahl(d[a.k]) > 0).map((a) => a.text(zahl(d[a.k]))).join(', ');
export const leergutFlaschen = (d: LeergutEingabe) =>
  LEERGUT_ARTEN.reduce((s, a) => s + zahl(d[a.k]) * a.zaehlt, 0);
export const leergutZahlen = (d: LeergutEingabe) =>
  Object.fromEntries(LEERGUT_ARTEN.filter((a) => zahl(d[a.k]) > 0).map((a) => [a.k, zahl(d[a.k])]));
export const leergutErfasst = (d: LeergutEingabe) => LEERGUT_ARTEN.some((a) => zahl(d[a.k]) > 0);

// Gespeicherte Werte → Eingabe; ältere Einträge nur als Text („10x Schweißgas, 2 Bündel 24x Treibgas“)
export function leergutAus(detail: Record<string, number> | null | undefined, text: string): LeergutEingabe {
  if (detail && Object.keys(detail).length) {
    return Object.fromEntries(Object.entries(detail).map(([k, v]) => [k, String(v)])) as LeergutEingabe;
  }
  const o: LeergutEingabe = {};
  for (const m of (text || '').matchAll(/(\d+)\s*x?\s*([A-Za-zÄÖÜäöüß]+)/g)) {
    const art = LEERGUT_ARTEN.find((a) => a.muster.test(m[2] ?? ''));
    if (art) o[art.k] = String(zahl(o[art.k]) + zahl(m[1]));
  }
  return o;
}

// Leergut automatisch aus „davon leer“ (Bestand): Bündel → Bündel, Treibgas → Treibgas, sonst Schweißgas.
// Tanks (zählt als 0 Flaschen) haben kein Leergut. Ergebnis leer = nichts gezählt → nichts vorschlagen.
export function leergutArtFuer(a: { artikel: string; groesse?: string; flaschen?: number }): LeergutArt | null {
  if ((a.flaschen ?? 1) === 0) return null;
  if (/treib/i.test(a.artikel)) return 'treibgas';
  if (/b[üu]ndel/i.test(a.artikel) || (a.groesse ?? '').trim() === '123') return 'buendel';
  return 'schweissgas';
}
export function leergutAusBestand(
  artikel: { artnr: string; artikel: string; groesse?: string; flaschen?: number }[],
  bestand: Record<string, { leer?: string }>,
): LeergutEingabe {
  const o: Partial<Record<LeergutArt, number>> = {};
  const bekannt = new Map(artikel.map((a) => [`${a.artnr}|${a.artikel}`, a]));
  for (const [k, v] of Object.entries(bestand)) {
    const n = zahl(v.leer);
    if (!n) continue;
    const a = bekannt.get(k) ?? { artikel: k.split('|')[1] ?? '', groesse: '' };
    const art = leergutArtFuer(a);
    if (art) o[art] = (o[art] ?? 0) + n;
  }
  return Object.fromEntries(Object.entries(o).map(([k, n]) => [k, String(n)])) as LeergutEingabe;
}
